import * as React from 'react';
import {PhotoshopPicker} from "react-color";
import useEventListener, { hexToHSL} from "../UploadUtils";
import {useCallback, useState} from "react";
import Modal from "react-responsive-modal";

interface BtnActionApplyOutlineProps {
  colorMain: string,
  applyOutlineChange: any,
  displayFinesse: boolean,
  contourCustom: boolean,
  disabled: boolean
}

export const _defineOutlineColor = (props: BtnActionApplyOutlineProps) => {
  const hslVal = hexToHSL(props.colorMain);
  if(hslVal && hslVal.l < 0.5) {
    return '#FFFFFF';
  }
  return '#000000';
}

export const BtnActionApplyOutline = (props: BtnActionApplyOutlineProps) => {
  const [colorOutline, setColorOutline] = useState(_defineOutlineColor(props));
  const [colorOutlinePickr, setColorOutlinePickr] = useState(_defineOutlineColor(props));
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [clickedElt, setClickedElt] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);

  const strTitle = props.displayFinesse ? 'Corriger' :  'Appliquer';
  const strTitle2 = props.displayFinesse ? ' avec un contour' :  ' un contour';
  const handler = useCallback(
    (elementClicked) => {
      if(clickedElt !== elementClicked) {
        setClickedElt(elementClicked);
        if (!findIdOfParent(elementClicked.target, 'pickrOutline')) {
          setShowColorPicker(false);
        }
      }
    },
    [setClickedElt ]
  );

  useEventListener('click', handler);

  function handleChangeColors(color: any) {
    setColorOutline(colorOutlinePickr);
    setShowColorPicker(!showColorPicker);
  }

  function findIdOfParent(obj:any, idParent: string) {
    const parentElement = document.getElementById(idParent);
    if(parentElement && parentElement.contains(obj)) {
      return true;
    }
    return false;
  }

  function confirmModaleAction(action: boolean, event: any = false) {
    if(action && event === false) {
        setOpenConfirm(action);
        if (action) {
          props.applyOutlineChange(true, colorOutline);
        }
    } else {
      const pickrOutline = document.getElementById('pickrOutline');
      const pickrOutlineElement = document.getElementById('pickrOutlineElement');
      if (pickrOutline) {
        if (!pickrOutline.contains(event.target)) {
          setOpenConfirm(action);
        } else {
          if (pickrOutlineElement && pickrOutlineElement.contains(event.target)) {
            event.preventDefault();
          } else {
            setShowColorPicker(!showColorPicker);
          }
        }
      }
    }
  }

  function handleChangeColorsOutline(color: any) {
    setColorOutlinePickr(color.hex);
  }

  function toogleShowColorPicker() {
      setShowColorPicker(!showColorPicker);
  }

  const confirmModale = () => {
    return (
      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)} center
             classNames={{overlay: 'bootstrap-container', modal: 'customModal',
               closeButton: ' closeButton'}}>
        <div className="p-2">
          <p className="text-center font18 bold">&Ecirc;tes-vous sûr de vouloir appliquer un contour sur votre visuel ?</p>
          <p className={'d-flex text-center justify-content-center align-items-center'}>Couleur du contour :

          <span id={'pickrOutline'} onClick={(e) => {confirmModaleAction(true,e)}} className={`btnBatAutoChangeColorContainer  ${!props.contourCustom ? '  ' : ' btnBatAutoChangeColorEnabled '}`}>

            <span className={`d-block ${!props.contourCustom ? ' cursor-not-allowed ' : ' cursor-pointer btnBatAutoChangeColor '}`} title={props.contourCustom ? 'Modifier la couleur du contour à appliquer' : 'La couleur du contour n\'est pas modifiable'} style={{ backgroundColor: `${colorOutline}`}}/>
            {(showColorPicker && props.contourCustom) &&
              <div className="photoshop-picker-custom">
                <PhotoshopPicker color={colorOutlinePickr} onAccept={handleChangeColors}  onCancel={toogleShowColorPicker}  onChangeComplete={handleChangeColorsOutline}/>
                </div>
            }
          </span>
          </p>
          <button title="Annuler" onClick={() => setOpenConfirm(false)}
                  className="border-0 bold bg-white cursor-pointer border-dark btnCancelModal float-left py-2 px-3">
            Non
          </button>
          <button title="Confirmer" onClick={() => confirmModaleAction(true)}
                  className="border-dark border bold bg-white cursor-pointer btnValidateModal float-right py-2 px-3">
            Oui
          </button>
        </div>
      </Modal>
    );
  };

  return (
    <div className=" col-lg-4 col-md-4 col-12  my-2 my-lg-0 align-items-center position-relative" >
      {confirmModale()}
      <div className={`align-items-center text-center d-flex btnBatAuto btnBatAutoPrimary justify-content-center py-3  black text-center w-100  ${props.disabled ? 'grey cursor-notAllowed opacDisabled ' : '  cursor-pointer '} `}   onClick={(e) => { props.disabled ?  setOpenConfirm(false)  : setOpenConfirm(true)}}>
        <button className={` border-0 bg-transparent  cursor-pointer`} id={'contourBtn'}>
            <span className={'bold'}>
               {strTitle}
            </span>
          <span>{strTitle2}</span>
        </button>
      </div>
    </div>
  );
}